import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded'
import { Box as BoxMaterial, FormControlLabel, Radio } from '@mui/material'
import checkIcon from 'assets/icons/check-icon.svg'
import TimePicker from 'rc-time-picker'
// @ts-ignore
import DatePicker from 'react-datepicker'
import styled, { CSSObject } from 'styled-components'
import { breakpoints, colors, fontFamily, fontWeight, typography } from 'theme'

/**
 * Hours Modal
 */
export const HoursAvailabilityTitle = styled.div`
  font-size: ${typography.xl.fontSize};
  font-family: ${fontFamily.inter};
  font-weight: ${fontWeight.semibold};
  color: ${colors.primary.medium};
  padding: 16px;
  box-sizing: border-box;
`

export const HoursAvailabilityWrapper = styled(BoxMaterial)`
  width: 100%;
  max-height: 100vh;
  overflow: scroll;
`

export const SectionEditIcon = styled.div`
  display: flex;
  align-items: center;
  color: ${colors.primary.light};
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.2s ease;
  pointer-events: none;

  &:hover {
    color: ${colors.primary.dark};
  }
`
export const SectionSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${colors.gray[300]};
`

export const SectionWrapper = styled.div<{ isEditingMode?: boolean }>`
  width: 100%;
  padding: 16px;
  box-sizing: border-box;
  transition: background-color 0.3s ease;

  ${({ isEditingMode }) =>
    !isEditingMode &&
    `
    &:hover {
      opacity: 1;
      pointer-events: auto;
      background-color: #0000001a;
    }

    &:hover ${SectionEditIcon} {
      opacity: 1;
      pointer-events: auto;
    }
  `}
`

export const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 8px;
`

export const SectionTitleContainer = styled.div`
  display: flex;
  align-items: center;
`

export const SectionTitle = styled.div`
  font-size: ${typography.xl.fontSize};
  font-family: ${fontFamily.inter};
  font-weight: ${fontWeight.semibold};
  color: ${colors.primary.medium};
  line-height: 140%;
  letter-spacing: 0%;
  vertical-align: bottom;
`

export const SectionContent = styled.div`
  margin-top: 1rem;
  border-radius: 8px;
`

/**
 * Hours Lists
 */
export const AvailabilityList = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
})

export const AvailabilityRow = styled.div<{ active?: boolean }>(
  {
    display: 'flex',
    padding: '8px',
    alignItems: 'baseline',
    gap: '6px',
    borderRadius: 0,
    width: 'fit-content',
  },
  ({ active }) =>
    active && {
      borderColor: colors.blue['700'],
    },
)

const mediumText = {
  color: colors.primary.medium,
  fontFamily: fontFamily.inter,
  fontSize: '13px',
  fontStyle: 'normal',
}

export const AvailableDay = styled.div<{ isHighlighted?: boolean }>(({ isHighlighted }) => ({
  ...mediumText,
  fontWeight: isHighlighted ? fontWeight.bold : fontWeight.medium,
  lineHeight: '19.5px',
  width: '162px',
  justifyContent: 'flex-start',
}))

export const AvailableTimeContainer = styled.div({
  display: 'grid',
  gridTemplateColumns: 'auto',
  gap: '4px',
  alignItems: 'flex-start',
})

export const AvailableTime = styled.div<{ isHighlighted?: boolean }>(({ isHighlighted }) => ({
  color: colors.primary.medium,
  fontFamily: fontFamily.inter,
  fontSize: typography.xxs.fontSize,
  fontStyle: 'normal',
  fontWeight: isHighlighted ? fontWeight.bold : fontWeight.normal,
  lineHeight: '19.5px',
}))

/**
 * Hours Forms
 */
export const MenuAvailabilityTableCtn = styled(BoxMaterial)<{ isModal?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: ${({ isModal }) => (isModal ? 0 : '45px')};
`

export const MenuAvailabilityTableRowContainer = styled(BoxMaterial)`
  display: flex;
  justify-content: start;
  align-items: center;
  height: 60px;
  gap: 16px;
  @media ${breakpoints.xs_max} {
    gap: 5px;
  }
`

export const MenuAvailabilityTableDayContainer = styled(BoxMaterial)`
  width: 90px;
`

export const DayClosedRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
`

export const CheckboxWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 18px;
  height: 18px;
  position: relative;
`

export const Checkbox = styled.input.attrs({ type: 'checkbox' })`
  width: 100%;
  height: 100%;
  appearance: none;
  border-radius: 2px;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #d7d7d7;
  background-color: transparent;

  &:checked {
    border: 2px solid #1b51a4;
    background-color: #1b51a4;
    background-image: url(${checkIcon});
    background-repeat: no-repeat;
    background-position: center;
    background-size: 12px 12px;
  }

  &:hover {
    opacity: 0.7;
  }
`

export const MenuAvailabilityTableTimePickerContainer = styled(BoxMaterial)`
  display: flex;
  width: 365px;
`

export const MenuAvailabilityTableSeparatorContainer = styled(BoxMaterial)`
  display: flex;
  flex-basis: 31px;
  margin: 16px;
  @media ${breakpoints.xs_max} {
    margin: 5px;
  }
  align-items: center;
`
export const MenuAvailabilityTableIconButtonContainer = styled(BoxMaterial)`
  display: flex;
  gap: 12px;
`

export const IconButton = styled.button.attrs({ type: 'button' })<{
  margin?: string
  width?: string
}>(
  {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 2,
    minWidth: 24,
  },
  ({ margin }) => margin && { margin },
  ({ width }) => width && { width },
)

export const MenuAvailabilityTableErrorText = styled(BoxMaterial)`
  color: red;
  text-align: end;
`

export const MenuAvailabilityErrorText = styled(BoxMaterial)`
  color: red;
  text-align: end;
`

export const MenuAvailabilityDialogActions = styled.div({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  marginTop: '2rem',
})

export const MenuAvailabilityTableLineSeparatorContainer = styled(BoxMaterial)`
  display: flex;
  margin: 8px;
  align-items: center;
  width: 100%;
`
export const LineSeparator = styled.div({
  height: '1px',
  width: '100%',
  background: colors.gray.medium,
})

export const SelectContainer: CSSObject = {
  width: 231,
  height: 47,
  marginTop: 10,
  marginBottom: 10,
}

export const SelectControl: CSSObject = {
  width: 231,
  height: 47,
  backgroundColor: colors.white,
  borderColor: colors.gray.medium,
}

export const SelectMenu: CSSObject = {
  width: 231,
}

export const SelectValueContainer: CSSObject = {
  color: colors.primary.medium,
  fontFamily: fontFamily.inter,
  fontWeight: 400,
  fontSize: 15,
  lineHeight: '150%',
}

export const SelectSingleValue: CSSObject = {
  color: colors.primary.medium,
  fontFamily: fontFamily.inter,
  fontWeight: 400,
  fontSize: 15,
  lineHeight: '150%',
}

export const CustomDateInput = styled(DatePicker)<{ error?: boolean }>`
  display: flex;
  padding: 8px 12px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  border: 1px solid ${({ error }) => (error ? '#C13030' : '#9e9e9e')};
  box-sizing: border-box;
  width: 100%;
  height: 47px;
  color: #666;
  font-family: ${fontFamily.inter};
  font-size: ${typography.semiXS.fontSize};
  font-style: normal;
  font-weight: 400;
  line-height: 150%;

  &:focus {
    outline: none;
    border: 1px solid ${({ error }) => (error ? '#C13030' : '#9e9e9e')};
    box-shadow: none;
  }
`

export const FormElement = styled(FormControlLabel)`
  margin-right: 0;
  width: fit-content;

  & .MuiFormControlLabel-label {
    color: #292929;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }
`

export const SectionLabel = styled.label`
  font-size: 14px;
  font-weight: bold;
`

export const StyledRadio = styled(Radio)`
  & svg {
    width: 20px;
    height: 20px;
  }
`

export const CustomTimeSectionWrapper = styled.div`
  margin-top: 8px;
`

export const TimePickersWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const StyledTimePicker = styled(TimePicker)<{ error?: boolean }>`
  height: 33px;
  width: 84px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;

  & .rc-time-picker-input {
    width: 84px;
    padding: 8px 12px;
    color: #484848;
    font-family: Inter;
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    border: 1px solid ${({ error }) => (error ? '#C13030' : '#D7D7D7')};

    &:focus {
      outline: none;
      border: 1px solid ${({ error }) => (error ? '#C13030' : '#D7D7D7')};
      box-shadow: none;
    }
  }
`

export const DatePickerWrapper = styled.div`
  width: 113px;

  input {
    padding: 8px 12px;
  }

  .react-datepicker-wrapper > div {
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`

export const ExpandMoreIcon = styled(ExpandMoreRoundedIcon)`
  color: #d7d7d7;
  transform: translateX(calc(-100% - 6px));
`

export const WarningTimeLabel = styled.div`
  color: #c13030;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

export const DateAlreadySetLabel = styled.div`
  color: #c13030;
  font-family: Inter;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
`

export const ClearIcon = styled(CloseRoundedIcon)`
  color: #d7d7d7;
  width: 18px;
  height: 18px;
  transform: translateX(calc(-100% - 6px));
  cursor: pointer;
`

export const HolidayHoursAvailabilityRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
`

export const HolidayHoursAvailableDay = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
`

export const HolidayHoursAvailableTimeContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`
